import React, { Fragment } from 'react'
// TODO:
// import { FormattedMessage } from '@dragonraider5/react-intl'
import { SectionTitle, SectionWrapper } from '../../../../components/Section';

function OrganizationWelcome() {
  return (
    <Fragment>
      <SectionTitle data-section='3'>
        Sobre la organización
      </SectionTitle>
      <SectionWrapper>
        <p>Rellena los datos básicos de tu organización en esta pantalla para que podamos obtener una visión general de la misma y de su proyecto de futuro.</p>
      </SectionWrapper>
    </Fragment>
  )
}

export default OrganizationWelcome
